export default "__VITE_ASSET__3e356846__"